import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import BoardsPage from 'pages/Admin/Boards';
import CategoriesPage from 'pages/Admin/Categories';
import StaffsPage from 'pages/Admin/Staffs';
import StaffEdit from 'pages/Admin/StaffEdit';
import BoardManagement from 'pages/Admin/BoardManagement';
import AnnualLeaveManagementPage from 'pages/Admin/AnnualLeave';
import ApprovalManagementPage from 'pages/Admin/Approval';
import PatentManagementPage from 'pages/Admin/Patent';
import AwardManagementPage from 'pages/Admin/Award';
import PerformanceManagementPage from 'pages/Admin/Performance';
import SiteManagement from 'pages/Admin/SiteManagement';
import SiteEdit from 'pages/Admin/SiteEdit';
import QualificationsPage from 'pages/Admin/Qualifications';
import SecurityPage from 'pages/Admin/Security';
import WebsiteManagementPage from 'pages/Admin/Website';

const AdminRoutes = () => (
    <Routes>
        <Route path="/qualifications" element={<QualificationsPage />}></Route>
        <Route path="/boards" element={<BoardsPage />}></Route>
        <Route path="/boards/:boardId/categories" element={<CategoriesPage />}></Route>
        <Route path="/board-management" element={<BoardManagement />}></Route>
        <Route path="/site-management" element={<SiteManagement />}></Route>
        <Route path="/site-management/:siteId/edit" element={<SiteEdit />}></Route>
        <Route path="/staffs" element={<StaffsPage />}></Route>
        <Route path="/staffs/:staffId" element={<StaffEdit />}></Route>
        <Route path="/annual-leave" element={<AnnualLeaveManagementPage />}></Route>
        <Route path="/approval" element={<ApprovalManagementPage />}></Route>
        <Route path="/patent" element={<PatentManagementPage />}></Route>
        <Route path="/award" element={<AwardManagementPage />}></Route>
        <Route path="/performance" element={<PerformanceManagementPage />}></Route>
        <Route path="/website" element={<WebsiteManagementPage />}></Route>
        <Route path="/security" element={<SecurityPage />}></Route>
        {/* 옛 주소 호환 */}
        <Route path="/download-logs" element={<Navigate to="/admin/security" replace />}></Route>
    </Routes>
);

export default AdminRoutes;
